import { TAddressType, TAddressTypeV2 } from '@features/userPanel/typescript';
import { IBasicAddress } from '@features/checkout/typescript';

export const getBaseAddress = (addresses: Array<IBasicAddress>) => {
  const addressType = TAddressTypeV2.base;
  const baseAddressList = addresses.filter((address: IBasicAddress) => address.type === addressType);

  if (baseAddressList.length === 0) {
    return null;
  }
  return baseAddressList.length > 0 ? baseAddressList[baseAddressList.length - 1] : null;
};

export const deliveryAddresses = (addresses: Array<IBasicAddress>): Array<IBasicAddress> | [] => {
  const addressType = TAddressTypeV2.delivery;
  const deliveryAddressList = addresses.filter((address: IBasicAddress) => address.type === addressType);

  return deliveryAddressList || [];
};

export const billingAddresses = (addresses: Array<IBasicAddress>): Array<IBasicAddress> | [] => {
  const addressType = TAddressTypeV2.invoice;
  const billingAddressList = addresses.filter((address: IBasicAddress) => address.type === addressType);

  return billingAddressList || [];
};

export const addressesOfType = (
  addresses: Array<IBasicAddress>,
  type: TAddressType | TAddressTypeV2,
): Array<IBasicAddress> | [] => {
  const billingAddressList = addresses.filter((address: IBasicAddress) => address.type === type);

  return billingAddressList || [];
};
